import { fetchClient } from '../../Utils/helpers';
import { setUserData } from '../../Utils/storages';
import {
  CHECKOUT_ADD_ON,
  GET_USER_DATA, GET_WALLET, SET_PIN, UPDATE_USER_DATA,
} from '../actionTypes';

export function getUserData(uid) {
  return {
    type: GET_USER_DATA,
    payload: fetchClient({
      method: 'GET',
      url: `/user/${uid}`,
    }).then((res) => {
      setUserData(res.data.data);
      return res;
    }),
  };
}

export function updateUserData(uid, data) {
  return {
    type: UPDATE_USER_DATA,
    payload: fetchClient({
      method: 'PUT',
      url: `/user/${uid}`,
      data,
    }).then((res) => {
      setUserData(res.data.data);
      return res;
    }),
  };
}

export function getWallet(uid, query = {}) {
  const { limit = 10, page = 1 } = query;
  return {
    type: GET_WALLET,
    payload: fetchClient({
      method: 'POST',
      url: `/user-wallet/${uid}?limit=${limit}&page=${page}`,
    }),
  };
}

export function setPin(uid, data) {
  return {
    type: SET_PIN,
    payload: fetchClient({
      method: 'POST',
      url: `/user-wallet/${uid}/pin`,
      data,
    }).then(() => getUserData(uid)),
  };
}

export function checkoutAddOn(uid, data) {
  return {
    type: CHECKOUT_ADD_ON,
    payload: fetchClient({
      method: 'POST',
      url: `/user-addons/${uid}/checkout`,
      data,
    }).then((res) => res.data),
  };
}
